import React, {Component} from 'react';
import './ErrorMessage.scss';
import parameterService from "../../services/parameterService";
import languageService from "../../services/languageService";

class ErrorMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorCode: this.getErrorCode()
        };
    }

    getErrorCode() {
        const serverErrorCode = parameterService.paygate.ErrorMessage;

        switch (serverErrorCode) {
            case '0015':
            case '0016':
                return 'checkCardNumber';
            case '0017':
            case '0094':
                return 'checkDateOfExpiry';
            case '0018':
                return 'checkCardBrand';
            case '0019':
                return 'checkCcv';
            case '0093':
                console.error('Server responded with: javascript not enabled');
                break;
            case '0100':
            case '0102':
            case '0110':
            case '0302':
            case '0304':
            case '0305':
            case '0306':
            case '0313':
            case '0314':
            case '0333':
            case '0356':
            case '0362':
                return 'selectDifferentCard';
            default:
                return serverErrorCode;
        }
    }

    render() {
        return (
            <div className="ErrorMessage pb-1">
                {this.state.errorCode && (<div className="form-error">
                    <div className="form-error-msg">
                        {languageService.texts.error[this.state.errorCode]}
                    </div>
                </div>)}
            </div>
        );
    }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.js